export default class CatalogPriceModel {
    constructor(data) {
        const mapping = {};

        ko.mapping.fromJS(data, mapping, this);
    }

    priceStyle = ko.pureComputed(() => {
        var styles = [];

        if (this.IsSpecialPrice()) styles.push("bargain");

        return styles.join(" ");
    })

    discountPercent = ko.pureComputed(() => {
        if (!this.ComparePrice()) {
            return null;
        }

        return `${Math.round((-1 + this.Price() / this.ComparePrice()) * 100)} %`;
    })
}